<template>
  <f7-page>
    <f7-navbar title="Not found" back-link="Back"></f7-navbar>
    <f7-block strong>
      <p>Sorry</p>
      <p>未能找到该页面</p>
    </f7-block>
  </f7-page>
</template>
<script>
  export default {};
</script>